

















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Audit } from "../../services/audit/entities/audit.interface";
import date from "../../utils/date";

@Component
export default class SingleAudit extends Vue {
  @Prop() audit!: Audit;

  private get formatDate(): string {
    return date.formatDate(this.audit.auditDate);
  }
}
